export const getLocalStorage = (item: string) => {
  return localStorage.getItem(item);
};

export const setLocalStorage = (item: string, values: any) => {
  return localStorage.setItem(item, values);
};
